import { observer } from 'mobx-react';
import React from 'react';
import ReactPaginate from 'react-paginate';

export interface IPagerProps {
    skip: number;
    pageSize: number;
    totalItems: number;
    pageRangeDisplayed?: number
    marginPagesDisplayed?: number
    onPageChange: (page: number) => void;
}

export const Pager = observer((props: IPagerProps) => {
    const currentPage = props.skip / props.pageSize;
    const handlePageChange = (props: IPagerProps, selectedPage: number) => {
        if (selectedPage !== currentPage) {
            props.onPageChange(selectedPage);
        }
    }

    return (<ReactPaginate
        forcePage={currentPage}
        pageCount={Math.ceil(props.totalItems / props.pageSize)}
        pageRangeDisplayed={props.pageRangeDisplayed ? props.pageRangeDisplayed : 5}
        marginPagesDisplayed={props.marginPagesDisplayed ? props.marginPagesDisplayed : 2}
        onPageChange={(args) => handlePageChange(props, args.selected)}
        breakClassName={'page-item'}
        breakLinkClassName={'page-link'}
        containerClassName={'pagination'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        activeClassName={'active'} />);
});

export default Pager;
